<template>
<div>

    <h3 class="mt-1 text-center">Facilitator Feedback Report</h3>
    <h5 class="text-blue-heading mt-3">{{ trainingDetails.title }}</h5>

    <div class="row mt-5">
        <div class="col-sm-6">
            <h5>Select an individual to view  ({{ allTrainers.length }})</h5>

        </div>
        
    </div>
    <!-- ------------------------------------- -->
    <div class="row">
        <div class="col-sm-3 mt-5" v-if="allTrainers">
            <div v-for="(trainer, tIndex) in allTrainers" v-bind:key="tIndex">
                <h5 :id="trainer.trainer.trainer_id_user" 
                     class="text-blue font-weight-bold common_trigger cur" 
                      v-if="trainer.trainer.trainer_user_id.name && tIndex == 0"
                      @click="loadFeedBack(trainer.trainer.trainer_id_user)"> 
                    {{ trainer.trainer.trainer_user_id.name }}
                </h5>
                <h5 :id="trainer.trainer.trainer_id_user" 
                    v-else-if="tIndex > 0 && trainer.trainer.trainer_user_id.name" class="common_trigger cur"
                    @click="loadFeedBack(trainer.trainer.trainer_id_user)">
                    {{ trainer.trainer.trainer_user_id.name }}
                </h5>
            </div>
        </div>
        <div class="col-sm-9 col-md-9 mt-5">
            <div v-for="(question, qIndex) in feedbackQuestions" :key="qIndex + 5" class="mb-4">
              <h6 class="pointer-class">
                <b>Q{{ qIndex + 1 }}. {{ question.question.title }}</b>
              </h6>
          
              <!-- Get matching feedback answer -->
              <div
                v-for="(answer, aIndex) in feedbackAns"
                :key="aIndex + 100"
                v-if="answer.options && answer.options.questionBank_id === question.question.id"
                class="pl-3"
              > 
                <!-- <h6 class="mt-2 mb-0">Feed Back</h6> -->
                <p class="text-success" v-if="answer.option_type == 'descriptive'">
                  {{ answer.option_value }}
                </p>
                <p class="text-success" v-else >
                  {{ answer.options.title }}
                </p>
              </div>
            </div>
          </div>

       
    </div>
    <!-- ------------------------------------- -->
</div>
</template>

<script>
import axios from "axios";
import $ from 'jquery';

export default {
    data: () => ({
        
        trainingCode: "",
        trainingID: "",
        allTrainers: [],
        trainingDetails: [],
        feedbackQuestions: [],
        feedbackAns:[],
        isSidebar: false,
        
    }),

    created() {},
    methods: {

      showTrainers(tId) {
        this.openLoading()
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/trainerdetails/report/get/" +
                    tId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.allTrainers = response.data.trainers;
                    //load first trainer assesment
                    if (
                        this.allTrainers &&
                        this.allTrainers[0] != undefined &&
                        this.allTrainers[0].trainer != undefined
                    ) {
                        this.showTrainerFeedback(
                            tId,
                            this.allTrainers[0].trainer.trainer_user_id.id

                        );
                       
                    }
                });
        },
      showTrainerFeedback(
            tId,
            trainerId
        ) {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/show/trainer-feedback/report/" +
                    trainerId +
                    "/" +
                    tId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data) {
                        this.feedbackQuestions = response.data.feedbackQuestions;
                        this.feedbackAns = response.data.feedbackResponse;
                    
                    }
                });
        },
        
        loadFeedBack(trainerId) {
            $(".common_trigger").removeClass("text-blue font-weight-bold");
            $("#" + trainerId).addClass("text-blue font-weight-bold");
      
            this.openLoading();
            this.showTrainerFeedback(this.trainingID, trainerId);
            this.closeLoading();
          },
        
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;
        // this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                if (response.data && response.data.training) {
                    this.trainingDetails = response.data.training;
                    this.trainingID = response.data.training.id;
                    this.showTrainers(response.data.training.id);
                }
            });
    }
};
</script>

<style scoped>
.text-blue {
    color: #00a4ea;
}

.btn-report {
    background-color: #6488d2 !important;
    border-radius: 0px !important;
    padding: 3px 30px !important;
}

.text-blue {
    color: #00a4ea;
    cursor: pointer !important;
    background-color: rgba(60, 60, 250, 0.055);
}

.text-blue-heading {
    color: #00a4ea;
}

.cur {
    cursor: pointer;
}

.cur:hover {
    background-color: rgba(60, 60, 250, 0.178);
}
</style>
